import { Dialog, DialogContent, DialogTitle, Grid, InputAdornment, TextField, Typography } from "@mui/material";
import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';
import { t } from "i18next";
import { CloseWithoutBorder, SearchIconGray } from '../../assets/images';
import { useAppSelector } from "../../store/hooks";
import { MuiStack } from "../atoms/stackComponent";
import Loader from "./loader";
var MuiDialogContent = styled(DialogContent)(function (_ref) {
    var theme = _ref.theme;
    return {
        "&.MuiDialogTitle-root+.css-ypiqx9-MuiDialogContent-root": {
        // paddingTop: '20px'
        },
        minWidth: 100
    };
});
export var MuiPopup = function (props) {
    var loader = useAppSelector(function (state) { return state.common.isLoader; });
    var id = props.id, _a = props.title, title = _a === void 0 ? "" : _a, _b = props.borderRadius, borderRadius = _b === void 0 ? "8px" : _b, openPopup = props.openPopup, children = props.children, subTitleVariant = props.subTitleVariant, variant = props.variant, onClose = props.onClose, subTitle = props.subTitle, _c = props.width, width = _c === void 0 ? 600 : _c, containerStyle = props.containerStyle, closeIcon = props.closeIcon, padding = props.padding, WarningCircle = props.WarningCircle, _d = props.lgMode, lgMode = _d === void 0 ? false : _d, backdropEnable = props.backdropEnable, headerIcon = props.headerIcon, subTitleStyle = props.subTitleStyle, _e = props.showLoaderOnPopup, showLoaderOnPopup = _e === void 0 ? false : _e, searchBox = props.searchBox, onSearchChange = props.onSearchChange;
    return /*#__PURE__*/ React.createElement(Dialog, {
        id: id,
        sx: {
            "& .css-12bx1vk-MuiPaper-root-MuiDialog-paper": {
                width: width,
                maxWidth: "100%"
            },
            zIndex: 1300
        },
        PaperProps: {
            sx: {
                borderRadius: {
                    borderRadius: borderRadius
                },
                marginX: lgMode ? "32px" : "16px"
            }
        },
        onClose: !backdropEnable ? onClose : null,
        open: openPopup
    }, /*#__PURE__*/ React.createElement(Grid, {
        container: true
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        padding: padding
    }, WarningCircle && /*#__PURE__*/ React.createElement(Grid, {
        item: true
    }, /*#__PURE__*/ React.createElement(IconButton, {
        id: title,
        "aria-label": "close",
        onClick: onClose,
        sx: {
            //position: 'absolute',
            left: 8,
            top: 8
        }
    }, /*#__PURE__*/ React.createElement("img", {
        src: WarningCircle,
        alt: "closeIcon",
        height: '24px',
        width: '24px'
    }))), /*#__PURE__*/ React.createElement(Grid, {
        item: true
    }, headerIcon && /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement("img", {
        src: headerIcon,
        alt: "header-icon"
    })), (title || subTitle) && /*#__PURE__*/ React.createElement(DialogTitle, {
        sx: {
            paddingTop: '24px',
            paddingBottom: 0
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        id: title,
        variant: variant,
        paddingBottom: '4px'
    }, title), /*#__PURE__*/ React.createElement(Typography, {
        id: "jobCardNo",
        variant: subTitleVariant,
        style: subTitleStyle
    }, subTitle)))), searchBox && /*#__PURE__*/ React.createElement(MuiStack, {
        id: "popup-search-stack",
        style: {
            width: '80%'
        },
        padding: "25px 0px 0px 10px"
    }, /*#__PURE__*/ React.createElement(TextField, {
        id: "popupsearch-inputbox",
        variant: "outlined",
        fullWidth: true,
        className: "Search",
        onChange: function (e) {
            var _e$target;
            return onSearchChange(e === null || e === void 0 || (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.value);
        },
        name: t('serial no'),
        sx: {
            '& .MuiInputBase-input': {
                height: '30px'
            },
            '& .MuiOutlinedInput-root': {
                height: '40px'
            }
        },
        InputProps: {
            startAdornment: /*#__PURE__*/ React.createElement(InputAdornment, {
                position: "start"
            }, /*#__PURE__*/ React.createElement("img", {
                src: SearchIconGray,
                alt: "Search-Icon-Gray"
            }))
        }
    }))), closeIcon && /*#__PURE__*/ React.createElement(Grid, {
        item: true
    }, /*#__PURE__*/ React.createElement(IconButton, {
        id: "popup-close-icon",
        "aria-label": "close",
        onClick: onClose,
        sx: {
            position: 'absolute',
            right: 8,
            top: searchBox ? 28 : 16,
            zIndex: 9999
        }
    }, /*#__PURE__*/ React.createElement("img", {
        src: CloseWithoutBorder,
        id: title ? title : "close-icon-popup",
        alt: "closeIcon",
        height: '24px',
        width: '24px'
    }))), loader.isLoaderOpen && showLoaderOnPopup ? /*#__PURE__*/ React.createElement(Loader, null) : /*#__PURE__*/ React.createElement("div", {
        style: {
            height: '4px'
        }
    }), /*#__PURE__*/ React.createElement(MuiDialogContent, {
        sx: containerStyle
    }, children));
};
